/* ==========================================================================
   The Harvest Company — Guide article minimal JS.
   Two responsibilities:
     1. FAQ accordion
     2. Tag the SPECIFIC ancestor chain of <article class="hc-guide"> with
        the hc-guide-host class so reset CSS only neutralizes containers
        that wrap the article — leaves header, footer, sibling elements
        untouched.
   ========================================================================== */

(function () {
  function init() {
    // FAQ accordion
    var faqItems = document.querySelectorAll('[data-hc-faq]');
    faqItems.forEach(function (item) {
      var btn = item.querySelector('.hc-guide-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    // Walk up from .hc-guide and tag each ancestor (stopping at <body>)
    // so reset CSS can target only this article's wrappers.
    var article = document.querySelector('.hc-guide');
    if (article) {
      var node = article.parentElement;
      while (node && node !== document.body && node !== document.documentElement) {
        node.classList.add('hc-guide-host');
        node = node.parentElement;
      }
    }

    initLightbox();
  }

  // Gallery lightbox: click a thumbnail to view full-size, with prev/next,
  // keyboard nav, backdrop/Escape to close. The overlay is moved to <body>
  // so position:fixed is never trapped by a transformed ancestor.
  function initLightbox() {
    var overlay = document.querySelector('[data-hc-lightbox-overlay]');
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-hc-lightbox]'));
    if (!overlay || triggers.length === 0) return;

    if (overlay.parentElement !== document.body) document.body.appendChild(overlay);

    var imgEl = overlay.querySelector('[data-hc-lb-img]');
    var counterEl = overlay.querySelector('[data-hc-lb-counter]');
    var btnPrev = overlay.querySelector('[data-hc-lb-prev]');
    var btnNext = overlay.querySelector('[data-hc-lb-next]');
    var btnClose = overlay.querySelector('[data-hc-lb-close]');
    var current = 0;
    var lastFocus = null;

    function show(index) {
      current = (index + triggers.length) % triggers.length;
      var t = triggers[current];
      imgEl.src = t.getAttribute('data-full');
      imgEl.alt = t.getAttribute('data-alt') || '';
      if (counterEl) counterEl.textContent = (current + 1) + ' / ' + triggers.length;
    }

    function open(index) {
      lastFocus = document.activeElement;
      show(index);
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hc-lb-open');
      btnClose.focus();
    }

    function close() {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('hc-lb-open');
      imgEl.src = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    triggers.forEach(function (t, i) {
      t.addEventListener('click', function () { open(i); });
    });
    btnPrev.addEventListener('click', function () { show(current - 1); });
    btnNext.addEventListener('click', function () { show(current + 1); });
    btnClose.addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', function (e) {
      if (overlay.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
